// auth.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Appkeys } from './app.keys';
import { TosterService } from './toster.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthService,
   private toastr: TosterService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    const token = localStorage.getItem(Appkeys.ACCESS_TOKEN);
    
    // Check if token exists and is expired
    if (token && this.authService.isTokenExpired()) {
      // Token is expired, redirect to login
      this.toastr.ShowError('Please login again.', 'Session expired');
      this.authService.logOut();
      this.router.navigate(['/login']);
      return throwError(() => new Error('Token expired'));
    }
    
    //console.log('intercept');
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token is invalid or expired
          this.toastr.ShowError('Please login again.', 'Session expired');
          this.authService.logOut();
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
